export type RegistrationFormDisplay = 'modal' | 'main-frame';
export type LogLevel = 'debug' | 'info' | 'warn' | 'error' | 'none';
export type Theme = 'dark' | 'light';
/** 'default' = Botoeira (device buttons) at the bottom, Eventos on the right.
 *  'swapped' = Botoeira on the right, Eventos at the bottom. */
export type OperationalLayout = 'default' | 'swapped';

export interface OperationalSettings {
  registrationFormDisplay: RegistrationFormDisplay;
  autoFaceDetection: boolean;
  logLevel: LogLevel;
  usePublicIpAsDirect: boolean; // When enabled, uses public IP for direct device comms instead of local IP
  theme: Theme;
  layout: OperationalLayout;
}

export const DEFAULT_OPERATIONAL_SETTINGS: OperationalSettings = {
  registrationFormDisplay: 'modal', // Default to existing behavior
  autoFaceDetection: false, // Disabled by default for better performance
  logLevel: 'error', // Only show errors by default
  usePublicIpAsDirect: false, // Default: use local IP for direct communication
  theme: 'dark', // Default to dark theme
  layout: 'default', // Default: Botoeira at the bottom, Eventos on the right
};
